import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { useTranslation } from "react-i18next";

import AccessControl from "../functional/AccessControl";

import BasicCrudScreenActionItemLayout from "../screenTypes/layout/BasicCrudScreenActionItemLayout";
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

import notificationState from "../../states/notificationState";

import getSchema from "../../lib/api/getSchema";

import DeleteRecordButton from "../input/DeleteRecordButton";
import SaveToExcelButton from "../input/SaveToExcelButton";
import EguSubMaterialSampleCreateRecordButton from "../input/EguSubMaterialSampleCreateRecordButton";
import EguSubMaterialSampleUpdateButton from "../input/EguSubMaterialSampleUpdateButton";

function EguSubMaterialSample() {

    const [tableSchema, setTableSchema] = useState();

    const [grid, setGrid] = useState();
    const [api, setApi] = useState();
    const [isEmpty, setIsEmpty] = useState();
    const [, setHeight] = useState();

    const [, setOnSelectMst] = useState();


    const [, setNotification] = useRecoilState(notificationState);

    const { t } = useTranslation();

    const handleResize = () => {

        setHeight(document.documentElement.offsetHeight - 96);

    };

    useEffect(() => {

        let mounted = true;

        window.addEventListener("resize", handleResize);

        handleResize();

        (async () => {

            let schema = await getSchema("EguSubMaterialSample");

            if (mounted) {
                setTableSchema(schema);
            }

        })();

        return (() => {
            mounted = false;
            window.removeEventListener("resize", handleResize);
        });

    }, []);

    useEffect(() => {

        (async () => {

            if (grid) {

                grid.selectionChanged.addHandler((grid, event) => {

                    if (grid.selectedItems && grid.selectedItems[0]) {

                        setOnSelectMst(grid.selectedItems[0]);

                    }
                });

                grid.itemsSourceChanged.addHandler((grid, event) => {

                    if (grid.selectedItems && grid.selectedItems[0]) {

                        setOnSelectMst(grid.selectedItems[0]);
                    }
                });
            }
        })();

    }, [grid]);

    const onLoadData = (data) => {

        setIsEmpty(data.length < 1 ? true : false)

    };

    const onInitialized = (grid) => {

        setGrid(grid);

    };

    const onApiInitialized = (api) => {

        setApi(api);

    };

    const notifySuccess = (msg) => {
        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });
    };

    const notifyFailure = (msg) => {
        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });
    };

    const notifyWarning = (msg) => {
        setNotification({
            severity: "warning",
            msg: msg,
            open: true,
        });
    };

    const onNotifyWarning = (msg) => {
        notifyWarning(msg);
    };

    const onFailure = (reason) => {
        notifyFailure(reason.response ? reason.response.data : reason);
    };

    const onSuccess = (msg) => {
        notifySuccess(msg);
    };

    const onAppendButtonInFrontOfSearch = () => {
        return (
            <>
                <BasicCrudScreenActionItemLayout>
                    <AccessControl
                        accessTarget={tableSchema && tableSchema.name}
                        accessMethod="POST"
                    >
                        <EguSubMaterialSampleCreateRecordButton
                            id="EguSubMaterialSample"
                            schema={tableSchema}
                            color="primary"
                            createButtonName="create"
                            onSuccess={onSuccess}
                            refresh={api}
                        />
                    </AccessControl>

                    <AccessControl
                        accessTarget={tableSchema && tableSchema.name}
                        accessMethod={
                            tableSchema && (tableSchema.updateWithPatch ? "PATCH" : "PUT")
                        }
                    >
                        <EguSubMaterialSampleUpdateButton
                            id="EguSubMaterialSample"
                            schema={tableSchema}
                            grid={grid}
                            refresh={api}
                            disabled={isEmpty}
                            onSuccess={onSuccess}
                        />
                    </AccessControl>

                    <AccessControl
                        accessTarget={tableSchema && tableSchema.name}
                        accessMethod="DELETE"
                    >
                        <DeleteRecordButton
                            id="EguSubMaterialSample"
                            schema={tableSchema}
                            grid={grid}
                            refresh={api}
                            color="secondary"
                            disabled={isEmpty}
                            onSuccess={onSuccess}
                            onFailure={onFailure}
                            onPartialFailure={onNotifyWarning}
                        />
                    </AccessControl>
                    <AccessControl
                        accessTarget={tableSchema && tableSchema.name}
                        accessMethod="SAVETOEXCEL"
                    >
                        <SaveToExcelButton
                            id="EguSubMaterialSample"
                            grid={grid}
                            view="EguVwSubMaterialSample"
                            color="primary"
                            disabled={isEmpty}
                        />
                    </AccessControl>
                </BasicCrudScreenActionItemLayout>
            </>
        );
    };

    return (
        <>
            <BasicCrudScreenType
                id="EguSubMaterialSample"
                table="EguSubMaterialSample"
                view="EguVwSubMaterialSample"
                headerTitle={t("term.subMaterialSample")}
                noCreate
                noEdit
                noDelete
                noExcel
                onLoadData={onLoadData}
                onInitialized={onInitialized}
                onApiInitialized={onApiInitialized}
                onAppendButtonInFrontOfSearch={onAppendButtonInFrontOfSearch}
                exportFormatItem={() => { }}
            />
        </>
    );
}

export default EguSubMaterialSample;
